import { Helmet } from 'react-helmet-async';
import { translates } from '@/utils/translate';
import { Button, Container } from '@mui/material';
import { PATH_DASHBOARD } from '@/routes/paths';
import CustomBreadcrumbs from '@/commons/custom-breadcrumbs';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Iconic } from '@/commons/iconic';
import ListPage from '@/components/Table';
import { TITLE } from '@utils/constants';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postTablesService } from '@/services/tables';
import { postUsersService } from '@/services';
import { useSnackbar } from '@/commons/snackbar';
import { useAuthContext } from '@/hooks/useAuthContext';
import TableNewEditForm from '../form/table';
import { TABLE_HEAD_TABLES } from '../utils/contants';
import { ITableAccountGeneral } from '../types';

export default function TablesListPage() {
  const title = translates.tables;
  const links = [
    {
      name: translates.dashboard,
      href: PATH_DASHBOARD.root,
    },
    {
      name: translates.table,
      href: PATH_DASHBOARD.tables.list,
    },
    { name: `${translates.new_table}` },
  ];
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { user } = useAuthContext();

  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['tables'],
    mutationFn: postTablesService,
    // mutationFn: postUsersService,
    onSuccess: (data: ITableAccountGeneral) => {
      queryClient.setQueryData(['tables', data?.id || ''], data);
      queryClient.invalidateQueries({ queryKey: ['tables'] });
      enqueueSnackbar('Create success company!');
      // navigate(PATH_DASHBOARD.users.list);
    },
    onError: (error: any) => {
      enqueueSnackbar(error, {
        variant: 'error',
      });
    },
  });

  const handleSubmit = async (dataForm: any) => {
    await mutateAsync({ ...dataForm, id: 11 });
  };

  return (
    <>
      <Helmet>
        <title> {TITLE}: Crear un nueva mesa </title>
      </Helmet>

      <Container maxWidth={false}>
        <CustomBreadcrumbs heading={`${translates.new_table}`} links={links} />
        <TableNewEditForm onSave={handleSubmit} />
      </Container>
    </>
  );
}
